export default __webpack_public_path__ + "6fc3bb29d91b6378d35712ca5be721c8.png";